import React, { ChangeEvent, FC } from 'react';
import { InputAdornment, TextField, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Field, FieldProps, getIn, useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { ContentInput } from 'api';

const useStyles = makeStyles(theme => ({
  inputField: {
    marginBottom: theme.spacing(2),
  },
  safe: {
    color: theme.palette.grey[600],
  },
  warning: {
    color: theme.palette.warning.main,
  },
  error: {
    color: theme.palette.error.main,
  },
}));

const TitleTextField: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { values, setFieldValue } = useFormikContext<ContentInput>();

  const value = getIn(values, 'content_object.title') || '';

  function onChange(event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) {
    setFieldValue(`content_object.title`, event.target.value);
  }

  function renderAdornment() {
    const length = value.length;
    const limit = 250;
    const difference = limit - length;
    const className = classNames({
      [classes.safe]: difference >= 21,
      [classes.warning]: difference <= 20,
      [classes.error]: difference < 0,
    });

    return (
      <InputAdornment variant="filled" position="end">
        <Typography className={className}>
          {length}/{limit}
        </Typography>
      </InputAdornment>
    );
  }

  return (
    <Field name="content_object.title">
      {({ field }: FieldProps<'content_object.title'>) => (
        <TextField
          fullWidth
          value={field.value}
          variant="outlined"
          placeholder={t('common:title')}
          className={classes.inputField}
          onChange={onChange}
          InputProps={{
            endAdornment: renderAdornment(),
          }}
        />
      )}
    </Field>
  );
};

export default TitleTextField;
